/* ============
 * Routes File
 * ============
 *
 * The routes and redirects are defined in this file
 */
const route = [
  // // Home
  // {
  //     path: '/home',
  //     name: 'home.index',
  //     component: require('pages/home/index/index.vue'),
  //
  //     // If the user needs to be authenticated to view this page
  //     meta: {
  //         auth: true,
  //     },
  // },

  // Superconciergerie
  {
    path: "/superconcierge",
    name: "superconcierge",
    component: require("pages/superconciergerie/superconciergerie.vue"),
    meta: {
      auth: true,
    },
  },
  {
    path: "/superconcierge/:tab?/:ownerId?/:year?/:month?/:type?",
    name: "superconcierge.tab",
    component: require("pages/superconciergerie/superconciergerie.vue"),
    meta: {
      auth: true,
    },
  },
  {
    path: "/superconcierge-invoice/:permalink?",
    name: "superconcierge.tab",
    component: require("pages/superconciergerie/invoice/invoice.vue"),
    meta: {
      auth: false,
    },
  },

  // stripeProcess
  {
    path: "/stripe-process",
    name: "stripe.process",
    component: require("pages/stripe-process/index/index.vue"),
    meta: {
      auth: true,
    },
  },

  // Accounts
  {
    path: "/account",
    name: "account.index",
    component: require("pages/account/index/index.vue"),

    // If the user needs to be authenticated to view this page
    meta: {
      auth: true,
    },
  },

  // Settings
  {
    path: "/account/settings",
    name: "account.settings",
    component: require("pages/account/settings/settings.vue"),
    meta: {
      auth: true,
    },
  },
  {
    path: "/account/settings/:tab?",
    name: "account.settings.tab",
    component: require("pages/account/settings/settings.vue"),
    meta: {
      auth: true,
    },
  },
  {
    path: "/migration_airbnb",
    name: "account.airbnb_account",
    component: require("pages/account/airbnb-account/airbnbAccount.vue"),
    meta: {
      auth: true,
    },
  },

  {
    path: "/new-user",
    name: "new.user.create",
    component: require("pages/account/users/users.vue"),
    meta: {
      auth: true,
    },
  },

  {
    path: "/update-user/:id",
    name: "update.team.user",
    component: require("pages/account/users/users.vue"),
    meta: {
      auth: true,
    },
  },

  {
    path: "/onboarding",
    name: "onboarding.user",
    component: require("pages/account/onboarding/Onboarding.vue"),
    meta: {
      auth: true,
    },
  },

  // Billing
  {
    path: "/billing",
    name: "billing.index",
    component: require("pages/billing/index/billing.vue"),
    meta: {
      auth: true,
    },
  },
  {
    path: "/billing/:tab?",
    name: "billing.index.tab",
    component: require("pages/billing/index/billing.vue"),
    meta: {
      auth: true,
    },
  },

  // Admin screen
  {
    path: "/admin",
    name: "admin.index",
    component: require("pages/admin/index/index.vue"),
    meta: {
      auth: true,
      admin: true,
    },
  },

  // Users
  {
    path: "/users",
    name: "users.index",
    component: require("pages/users/index/index.vue"),
    meta: {
      auth: true,
    },
  },

  {
    path: "/users/:id",
    name: "users.details",
    component: require("pages/users/detail/detail.vue"),
    meta: {
      auth: true,
    },
  },

  {
    path: "/users-create",
    name: "users.create",
    component: require("pages/users/detail/detail.vue"),
    meta: {
      auth: true,
    },
  },

  // Payments
  {
    path: "/payments",
    name: "payments.index",
    component: require("pages/payments/index/index.vue"),
    meta: {
      auth: true,
    },
  },
  {
    path: "/payments/messages",
    name: "payment.messages",
    component: require("pages/payments/messages/messages.vue"),
    meta: {
      auth: true,
      admin: true,
    },
  },

  // Schedule payment
  {
    path: "/payments/schedule-payment",
    name: "payments.schedule-payment",
    component: require("pages/payments/index/index.vue"),
    meta: {
      auth: true,
    },
  },
  {
    path: "/payments/:id",
    name: "payments.detail",
    component: require("pages/payments/detail/detail.vue"),
    meta: {
      auth: true,
    },
  },

  // Bookings
  {
    path: "/bookings",
    name: "bookings.index",
    component: require("pages/bookings/index/index.vue"),
    meta: {
      auth: true,
    },
  },

  {
    path: "/bookings/:id/informations",
    name: "bookings.details",
    component: require("pages/bookings/details/details.vue"),
    meta: {
      auth: true,
    },
  },

  {
    path: "/bookings/:id/:tab",
    name: "bookings.details.tab",
    component: require("pages/bookings/details/details.vue"),
    meta: {
      auth: true,
    },
  },

  {
    path: "/bookings-create",
    name: "bookings.create",
    component: require("pages/bookings/details/details.vue"),
    meta: {
      auth: true,
    },
  },

  {
    path: "/bookings-create/:tab",
    name: "bookings.create.tab",
    component: require("pages/bookings/details/details.vue"),
    meta: {
      auth: true,
    },
  },

  {
    path: "/bookings-create/:checking/:checkout/:rental",
    name: "bookings.create.data",
    component: require("pages/bookings/details/details.vue"),
    meta: {
      auth: true,
    },
  },

  {
    path: "/booking/:permalink/contract",
    name: "bookings.contract",
    component: require("pages/bookings/contract/contract.vue"),
  },

  {
    path: "/invoice/:permalink/edit",
    name: "bookings.invoice.edit",
    component: require("pages/bookings/invoice/invoice.vue"),
    // meta: {
    //     auth: false,
    // },
  },

  {
    path: "/invoice/:permalink",
    name: "bookings.invoice",
    component: require("pages/bookings/invoice/invoice.vue"),
    // meta: {
    //   auth: false
    // },
  },

  {
    path: "/get-available-rentals/:webKey/:lang?/:groups?",
    name: "rental.availabilities",
    component: require("pages/external-availability/index.vue"),
  },
  {
    path: "/rental/:propertyKey",
    name: "rental.detail",
    component: require("pages/external-availability/detail.vue"),
  },
  {
    path: "/create-booking/:propertyKey",
    name: "booking.create",
    component: require("pages/external-availability/checkout.vue"),
  },
  {
    path: "/create-confirmation/:propertyKey/:checkin/:checkout/:adultsCount/:childrenCount/:duration/:price/:tax/:lang?",
    name: "booking.confirmation",
    component: require("pages/external-availability/confirmation.vue"),
  },
  {
    path: "/confirm-3ds-authentication/:reservationId",
    name: "threedsecure.confirmation",
    component: require("pages/payments/confirm3dsAuthentication/confirm3dsAuthentication.vue"),
  },
  // Analytics index tab
  {
    path: "/analytics",
    name: "analytics.index",
    component: require("pages/analytics/index/index.vue"),
    meta: {
      auth: true,
    },
  },
  // Analytics rentals tab
  // {
  //   path: '/analytics/rentals',
  //   name: 'analytics.rentals.tab',
  //   component: require('pages/analytics/rentals/rentals.vue'),
  //   meta: {
  //     auth: true,
  //   },
  // },
  // Analytics reviews tab
  {
    path: "/analytics/reviews",
    name: "analytics.reviews.tab",
    component: require("pages/analytics/reviews/reviews.vue"),
    meta: {
      auth: true,
    },
  },
  // Analytics general tab
  {
    path: "/analytics/general/:id?",
    name: "analytics.general.tab",
    component: require("pages/analytics/general/general.vue"),
    meta: {
      auth: true,
    },
  },
  // Analytics environment tab
  {
    path: "/analytics/environment/:id?",
    name: "analytics.environment.tab",
    component: require("pages/analytics/environment/environment.vue"),
    meta: {
      auth: true,
    },
  },
  // Analytics market tab
  {
    path: "/analytics/market/:id?/:start/:end",
    name: "analytics.market.tab",
    component: require("pages/analytics/market/market.vue"),
    meta: {
      auth: true,
    },
  },

  // Analytics current tab
  {
    path: "/analytics/current",
    name: "analytics.current.tab",
    component: require("pages/analytics/current/current.vue"),
    meta: {
      auth: true,
    },
  },

  // Calendar
  {
    path: "/calendar",
    name: "calendar.index",
    component: require("pages/calendar/index/index.vue"),
    meta: {
      auth: true,
    },
  },

  {
    path: "/calendar/:type",
    name: "calendar.type",
    component: require("pages/calendar/index/index.vue"),
    meta: {
      auth: true,
    },
  },

  // Rentals
  {
    path: "/rentals",
    name: "rentals.index",
    component: require("pages/rentals/index/index.vue"),
    meta: {
      auth: true,
    },
  },

  {
    path: "/rentals/:id",
    name: "rentals.detail",
    component: require("pages/rentals/detail/detail.vue"),
    meta: {
      auth: true,
    },
  },

  {
    path: "/rentals/:id/:tab",
    name: "rentals.detail.tab",
    component: require("pages/rentals/detail/detail.vue"),
    meta: {
      auth: true,
    },
  },

  {
    path: "/rentals-create",
    name: "rentals.create",
    component: require("pages/rentals/detail/detail.vue"),
    meta: {
      auth: true,
    },
  },

  {
    path: "/open-door/:type/:hash",
    name: "rental.open.door",
    component: require("pages/rentals/open-door/open-door.vue"),
  },

  {
    path: "/close-door/:type/:hash",
    name: "rental.close.door",
    component: require("pages/rentals/close-door/close-door.vue"),
  },

  {
    path: "/open-or-close-door/:type/:hash",
    name: "rental.openOrClose.door",
    component: require("pages/rentals/open-or-close-door/open-or-close-door.vue"),
  },

  {
    path: "/open-or-close-rental-door/:hash",
    name: "rental.openOrCloseRental.door",
    component: require("pages/rentals/open-or-close-rental-door/open-or-close-rental-door.vue"),
  },

  {
    path: "/market",
    name: "market.index",
    component: require("pages/market/index/index.vue"),
    meta: {
      auth: true,
    },
  },
  {
    path: "/ical/bookings.ics/:permalink",
    name: "rental.exportIcs",
    component: require("pages/rentals/exportIcs/exportIcs.vue"),
    meta: {},
  },

  // Automation
  {
    path: "/automation",
    name: "automation.index",
    component: require("pages/automation/index/index.vue"),
    meta: {
      auth: true,
    },
  },

  {
    path: "/automation/custom-short-codes",
    name: "automation.custom-short-codes",
    component: require("pages/automation/index/index.vue"),
    meta: {
      auth: true,
    },
  },

  // Messages
  {
    path: "/messages/:id?",
    name: "messages.index",
    component: require("pages/messages/index/index.vue"),
    meta: {
      auth: true,
    },
  },
  // Contract
  {
    path: "/admin/:tab",
    name: "admin.index.tab",
    component: require("pages/admin/index/index.vue"),
    meta: {
      auth: true,
      admin: true,
    },
  },
  {
    path: "/admin/:type/:id?",
    name: "admin.template.edit",
    component: require("pages/admin/template/edit/edit.vue"),
    meta: {
      auth: true,
      admin: true,
    },
  },
  {
    path: "/admin/:type/create",
    name: "admin.template.create",
    component: require("pages/admin/template/edit/edit.vue"),
    meta: {
      auth: true,
      admin: true,
    },
  },
  // Login
  {
    path: "/login",
    name: "login.index",
    component: require("pages/login/index/index.vue"),

    // If the user needs to be a guest to view this page
    meta: {
      guest: true,
      staticPwdPassed: true,
    },
  },
  // Payment success
  {
    path: "/p/:permalink/:status",
    name: "payment.success",
    component: require("pages/payments/success/success.vue"),
  },

  // Permalink
  {
    path: "/p/:permalink",
    name: "payment.permalink",
    component: require("pages/payments/permalink/permalink.vue"),
  },
  // Connect card data
  {
    path: "/connect/:permalink",
    name: "connect.permalink",
    component: require("pages/users/card-connect/CardConnect.vue"),
  },
  // Password
  {
    path: "/password",
    name: "password.index",
    component: require("pages/password/index/index.vue"),

    // If the user needs to be a guest to view this page
    meta: {
      guest: true,
      staticPwdPassed: true,
    },
  },

  {
    path: "/reset/password/:token/:email",
    name: "password.reset",
    component: require("pages/password/reset/reset.vue"),
    meta: {
      guest: true,
      staticPwdPassed: true,
    },
  },

  // Preview form
  {
    path: "/preview-form/:id",
    name: "form.preview",
    component: require("pages/form/preview/index.vue"),
    meta: {
      auth: true,
    },
  },
  // Show form for booking
  {
    path: "/booking/:booking_permalink/:form_type",
    name: "form.show",
    component: require("pages/form/show/show.vue"),
    meta: {},
  },

  {
    path: "/account/events",
    name: "account.events",
    component: require("pages/account/events/events.vue"),
    meta: {
      auth: true,
    },
  },

  {
    path: "/account/team",
    name: "account.team",
    component: require("pages/account/team/team.vue"),
    meta: {
      auth: true,
    },
  },
  {
    path: "/unlock/:email",
    name: "unlock",
    component: require("pages/account/Unlock.vue"),
  },
];

if (process.env.REGISTRATION_PAGE) {
  route.push(
    // Register
    {
      path: "/register/:via?",
      name: "register.index",
      component: require("pages/register/index/index.vue"),

      // If the user needs to be a guest to view this page
      meta: {
        guest: true,
        staticPwdPassed: true,
      },
    }
  );
}

route.push(
  {
    path: "/register/verify/:confirmation_code",
    name: "confirm.index",
    component: require("pages/confirm/index/index.vue"),
  },
  {
    path: "/",
    redirect: "/calendar",
    // If the user needs to be a guest to view this page
    meta: {
      auth: true,
    },
  },
  {
    path: "/",
    name: "static-pwd.index",
    component: require("pages/static-pwd/index/index.vue"),

    // If the user needs to be a guest to view this page
    meta: {
      guest: true,
      staticPwdPassed: false,
    },
  },

  {
    path: "/*",
    redirect: "/",
  }
);
/**
 * The routes
 *
 * @type {object} The routes
 */
export default route;



// WEBPACK FOOTER //
// ./src/app/routes.js